import * as React from 'react'
import { View } from 'react-native'
import styled from '@theme/styled-components'

import Root from '@components/root/Root'
import Button from '@components/button/Button'
import SimpleAlert from '@components/modal/SimpleAlert'

import useI18n from '@i18n/useI18n'
import useNavigation from '@layout/useNavigation'

import useReducer from '@store/useReducer'
import * as UserStore from '@store/user/user'

import api from '@api/api'

import logger from '@utils/logger'

interface Props {
  user: UserResponse
}

const AccountIdentificationScreen = () => {
  const user = useReducer(UserStore.store, (s) => s.user)

  // screen available only for connected user
  if (!user) {
    return null
  }

  return <Screen user={user} />
}

const Screen = ({ user }: Props) => {
  const i18n = useI18n()
  const navigation = useNavigation()

  const [sending, setSending] = React.useState(false)

  const errorAlert = () => {
    SimpleAlert.open({
      title: i18n.t('common.errorTitle'),
      description: i18n.t('common.error'),
      buttons: [{ label: i18n.t('common.ok'), onClick: () => SimpleAlert.close() }],
    })
  }

  const onResetPassword = () => {
    setSending(true)
    api.authentification
      .forgottenPassword(user.email)
      .then(() => {
        SimpleAlert.open({
          title: i18n.t('common.success'),
          description: i18n.t('screens.account.identificationSection.resetPasswordSuccess', { email: user.email }),
          buttons: [
            {
              label: i18n.t('common.ok'),
              onClick: () => {
                SimpleAlert.close()
              },
            },
          ],
        })
      })
      .catch((err) => {
        logger.error(err)
        errorAlert()
      })
      .finally(() => {
        setSending(false)
        navigation.goBack()
      })
  }

  return (
    <Root onLeft={navigation.goBack} header={i18n.t('screens.account.mobileSections.identification')}>
      <ButtonContainer>
        <Button
          label={i18n.t('screens.account.identificationSection.resetPassword')}
          status={sending ? 'loading' : 'active'}
          onClick={() => onResetPassword()}
        />
      </ButtonContainer>
    </Root>
  )
}

export default AccountIdentificationScreen

const ButtonContainer = styled(View)`
  padding: 32px 16px;
`
